import React, { useState } from "react";

import Context from "./index";

import {
  alertError,
  alertSuccess,
} from "../../../Shared/Utils/alertMessages.js";
import {
  errorGettingData,
  errorInsertingData,
  errorUpdatingData,
  genericError,
  ItemUpdated,
  successDeleted,
} from "../../../Shared/Constants/index.jsx";

import { createEntityApi } from "../Api/CreateEntitiy.js";
import { updateEntityApi } from "../Api/UpdateEntity.js";
import { deleteEntityApi } from "../Api/DeleteEntity.js";
import { showEntityApi } from "../Api/ShowEntity.js";
import { getEntitiesApi } from "../../../Shared/Api/GetEntities.js";
import { alertToastErrorFromResponse } from "../../../Shared/Utils/errorUtils.js";

const EntityProvider = (props) => {
  const [tableData, setTableData] = useState([]);
  const [apiErrors, setApiErrors] = useState([]);
  const [item, setItem] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [modal, setModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const modalTogle = () => {
    setModal(!modal);
  };

  const getItem = async (id) => {
    setLoading(true);
    try {
      let response = await showEntityApi(id);
      let data = response.data;
      if (response.result === "success") {
        setItem(data);
      } else {
        alertToastErrorFromResponse(errorGettingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    } finally {
      setLoading(false);
    }
  };
  //List objects frokm db
  const fetchTableData = async (page, limit) => {
    setLoading(true);
    try {
      let response = await getEntitiesApi({
        search: searchTerm,
        page: page,
        limit: limit,
      });
      let data = response.data;
      if (response.result === "success") {
        setTableData(data.items); // Append new data
        setTotalRows(data.totalRows); // Append new data
      } else {
        setTableData([]); // Append new data
        setTotalRows(0); // Append new data
        alertToastErrorFromResponse(errorGettingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    } finally {
      setLoading(false);
    }
  };

  //Create object
  const createItem = async (data) => {
    setSaving(true);
    try {
      let response = await createEntityApi(data);

      if (response?.result && response?.result == "success") {
        alertSuccess("Registro creado !");
        fetchTableData(currentPage, rowsPerPage);
        modalTogle();
        setApiErrors([]);
      } else {
        alertToastErrorFromResponse(errorInsertingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    } finally {
      setSaving(false);
    }
  };

  //edit item
  const updateItem = async (data, id) => {
    setSaving(true);
    try {
      let response = await updateEntityApi(data, id);

      if (response?.result && response?.result == "success") {
        // Crear una nueva copia de tableData
        fetchTableData(currentPage, rowsPerPage);

        alertSuccess(ItemUpdated);

        modalTogle();
        setApiErrors([]);
      } else {
        alertToastErrorFromResponse(errorUpdatingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    } finally {
      setSaving(false);
    }
  };

  //delete item
  const deleteItem = async (id) => {
    setLoading(true);
    try {
      let response = await deleteEntityApi(id);

      if (response?.result && response?.result == "success") {
        const newdata = tableData.filter((elem) => {
          return id !== elem.id;
        });
        setTableData(newdata);
        alertSuccess(successDeleted);
        setApiErrors([]);
      } else {
        alertToastErrorFromResponse(errorDeleteingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (row) => {
    let editObject = tableData.find((e) => e.id === row.id);
    setItem(editObject);
    setApiErrors([]);
  };

  return (
    <Context.Provider
      value={{
        ...props,
        tableData,
        createItem,
        updateItem,
        deleteItem,
        fetchTableData,
        setCurrentPage,
        setRowsPerPage,
        setLoading,
        apiErrors,
        modalTogle,
        modal,
        setItem,
        item,
        loading,
        currentPage,
        totalRows,
        handleEdit,
        rowsPerPage,
        searchTerm,
        setSearchTerm,
        saving,
        setSaving,
        getItem,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};
export default EntityProvider;
